import fin1 from '../images/finland/EV2A7874.jpg'
import fin2 from '../images/finland/EV2A7955.jpg'
import fin3 from '../images/finland/EV2A7565.jpg'
import fin4 from '../images/finland/EV2A1958.jpg'
import fin5 from '../images/finland/QA1A0574.jpg'
import fin6 from '../images/finland/EV2A1109.jpg'
import fin7 from '../images/finland/QA1A5378.jpg'
import fin8 from '../images/finland/QA1A0603.jpg'

export const finlandData = [
  {
    id: 1,
    image: fin1,
    alignment: 'horizontal',
    alt: 'Finland image 1 Jari Sokka'
  },
  {
    id: 2,
    image: fin2,
    alignment: 'horizontal',
    alt: 'Finland image 2 Jari Sokka'
  },
  {
    id: 3,
    image: fin3,
    alignment: 'horizontal',
    alt: 'Finland image 3 Jari Sokka'
  },
  {
    id: 4,
    image: fin4,
    alignment: 'horizontal',
    alt: 'Finland image 4 Jari Sokka'
  },
  {
    id: 5,
    image: fin5,
    alignment: 'horizontal',
    alt: 'Finland image 5 Jari Sokka'
  },
  {
    id: 6,
    image: fin6,
    alignment: 'horizontal',
    alt: 'Finland image 6 Jari Sokka'
  },
  {
    id: 7,
    image: fin7,
    alignment: 'horizontal',
    alt: 'Finland image 7 Jari Sokka'
  },
  {
    id: 8,
    image: fin8,
    alignment: 'horizontal',
    alt: 'Finland image 8 Jari Sokka'
  }
]